import { store } from '../store/store';

// Break state that can be read synchronously, from anywhere.
//
// WHY THIS EXISTS
// `breakDetails` in Redux is the committed break state, but it only lands AFTER two
// awaited HTTP round-trips (`/call_originate/unregister_call`, then
// `/breaks/agent_break`). The first of those already tells the switch to drop the
// agent — so between the click and the commit there is a window, easily hundreds of
// milliseconds, in which the server considers the agent gone while the UI is still
// fully live and unguarded. The HANGUP the switch emits as a direct result of the
// agent's own break click lands inside exactly that window, which is how a WRAPUP
// status and a CRM screen appear on top of a break.
//
// `breakPending` closes that window: it is latched synchronously on click, before the
// first await, and handed off to `breakDetails` once the break commits.
//
// It is deliberately module-level rather than Redux state: the whole `dial` slice is
// persisted with no whitelist (see store.js), and a `true` value surviving into
// localStorage would leave the agent permanently deaf to call events with no break to
// end. A module-level flag resets on reload, which is the correct behaviour — a reload
// cancels any in-flight break request anyway.
let breakPending = false;

export const setBreakPending = (value) => {
  breakPending = !!value;
};

// The single break check for socket handlers, timers, and any async continuation that
// resumes after an await. Covers both the pre-commit window and the committed break,
// so callers never have to know which phase they are in.
export const isOnBreakNow = () => breakPending || !!store.getState()?.dial?.breakDetails;
